const asyncValidate = (values, dispatch, props) => {
  let blurredField = props.lastBlurred;

  //this function tackles cases when redux-form touches a field automatically and async is called but blur is not
  if (!blurredField) {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    const asyncValidate = (values /*, dispatch */) => {
      return sleep(0) // simulate server latency
        .then(() => {});
    };
    return asyncValidate(values);
  }

  if (blurredField === "submit") {
    return props.proceedStep(props.basketId, "confirm").then(res => {
      //console.log('in proceed step in asyncValidate?!', res);

      if (res.hasFailed) {
        //console.log(res);
        let error = {
          _error: res.data.continueText
        };
        throw error;
      }
    });
  }

  // console.log('lastblurred in async', blurredField, props);
  switch (blurredField) {
    case "skiSnowboards":
      blurredField = "numberOfSkis";
      break;
    case "bikesSurfboards":
      blurredField = "numberOfBikes";
      break;
    case "holdLuggage":
      blurredField = "numberOfHoldItems";
      break;
    case "phone":
      blurredField = "mobile";
      break;
    case "firstName":
      blurredField = "forename";
      break;
    case "lastName":
      blurredField = "surname";
      break;
    case "flying":
      blurredField = "flightTimeOverride";
      break;
    default:
      break;
  }
  let apiResponse = { [blurredField]: values[props.lastBlurred] };

  //Exceptions
  if (blurredField.includes("childAge")) {
    const id = props.transfers.children[blurredField.substring(8)]["id"];
    apiResponse = { children: [{ id, age: values[props.lastBlurred] }] };
  }
  if (blurredField.includes("seatType")) {
    const id = props.transfers.children[blurredField.substring(8)]["id"];
    apiResponse = {
      children: [{ id, seatType: { code: values[props.lastBlurred] } }]
    };
  }
  if (blurredField === "transferType")
    apiResponse = { [blurredField]: { code: values[props.lastBlurred] } };
  if (blurredField === "children")
    apiResponse = { numberOfChildren: values[props.lastBlurred] };
  if (blurredField === "accommodationAddress")
    apiResponse = { fromAccommodation: { street: values[props.lastBlurred] } };
  if (blurredField === "accommodationName")
    apiResponse = { fromAccommodation: { name: values[props.lastBlurred] } };
  if (blurredField === "toAccommodationAddress")
    apiResponse = { toAccommodation: { street: values[props.lastBlurred] } };
  if (blurredField === "toAccommodationName")
    apiResponse = { toAccommodation: { name: values[props.lastBlurred] } };
  if (blurredField === "busNumber")
    apiResponse = { shuttle: { bus: { id: values[props.lastBlurred] } } };
  if (blurredField === "departureStop")
    apiResponse = {
      shuttle: { departureStop: { id: values[props.lastBlurred] } }
    };
  if (blurredField === "arrivalStop")
    apiResponse = {
      shuttle: { arrivalStop: { id: values[props.lastBlurred] } }
    };
  return props
    .postBasketData(
      props.basketId,
      props.idValue,
      apiResponse,
      blurredField === "children" ||
        blurredField === "adults" ||
        blurredField === "numberOfHoldItems" ||
        blurredField === "numberOfBikes" ||
        blurredField === "numberOfSkis" ||
        blurredField === "transferType"
        ? true
        : false,
        false,
        props.activeKey === "3" ? "STP3" : null 
    )
    .then(result => {
      if (result.hasFailed) {
        const myArr = result.data.error_messages.reduce((obj, item) => {
          let name = item.validation_field.substring(11);
          switch (name) {
            case "numberOfSkis":
              name = "skiSnowboards";
              break;
            case "numberOfBikes":
              name = "bikesSurfboards";
              break;
            case "numberOfHoldItems":
              name = "holdLuggage";
              break;
            case "transfer_type":
              name = "transferType";
              break;
            case "mobile":
              name = "phone";
              break;
            case "forename":
              name = "firstName";
              break;
            case "surname":
              name = "lastName";
              break;
            case "accommodationName":
              name = ["fromAccommdation"]["name"];
              break;
            case "accommodationAddress":
              name = ["fromAccommdation"]["address"];
              break;
            case "toAccommodationName":
              name = ["toAccommdation"]["name"];
              break;
            case "toAccommodationAddress":
              name = ["toAccommdation"]["address"];
              break;
            case "flightTimeOverride":
              name = "flying";
              break;
            default:
              break;
          }
          obj[name] = item.message;
          return obj;
        }, {});
        throw myArr;
      }
    });
};

export default asyncValidate;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/YourSummaryPanel/form/asyncValidate.js